import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import AnimateOnScroll from './AnimateOnScroll';
import { footerContent } from '../content/landingContent';

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: id } });
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer id="contact" className="bg-stone-50 border-t border-stone-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <AnimateOnScroll>
          <div className="grid md:grid-cols-2 gap-12 mb-12">
            <div className="space-y-4">
              <img 
                src="/Practicio_logo.png" 
                alt="Practicio" 
                className="h-8"
              />
              <p className="text-stone-600 max-w-md leading-relaxed">
                {footerContent.tagline}
              </p>
              <div className="pt-4">
                <p className="text-sm text-stone-500 mb-2">Get in touch</p>
                <a href={`mailto:${footerContent.email}`} className="text-slate-600 hover:text-slate-700 transition-colors font-medium">
                  {footerContent.email}
                </a>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-8">
              {footerContent.sections.map((section, index) => (
                <div key={index}>
                  <h4 className="font-semibold text-stone-900 mb-4">{section.title}</h4>
                  <ul className="space-y-3">
                    {section.links.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        {link.href.startsWith('#') ? (
                          <button 
                            onClick={() => scrollToSection(link.href.substring(1))}
                            className="text-stone-500 hover:text-stone-900 transition-colors duration-200"
                          >
                            {link.label}
                          </button>
                        ) : link.href.startsWith('/') ? (
                          <Link to={link.href} className="text-stone-500 hover:text-stone-900 transition-colors duration-200">
                            {link.label}
                          </Link>
                        ) : (
                          <a href={link.href} className="text-stone-500 hover:text-stone-900 transition-colors duration-200">
                            {link.label}
                          </a>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </AnimateOnScroll>
        
        <div className="pt-8 border-t border-stone-200">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-stone-500">
              {footerContent.copyright}
            </p>
            <div className="flex space-x-6">
              {footerContent.legal.map((link, index) => (
                link.href.startsWith('/') ? (
                  <Link key={index} to={link.href} className="text-sm text-stone-500 hover:text-stone-900 transition-colors duration-200">
                    {link.label}
                  </Link>
                ) : (
                  <a key={index} href={link.href} className="text-sm text-stone-500 hover:text-stone-900 transition-colors duration-200">
                    {link.label}
                  </a>
                )
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;